export function concatProductsTitle(products) {
  const title = [];
  const loop_max = products.length > 5 ? 5 : products.length;
  for (let i = 0; i < loop_max; i++) {
    const product = products[i];
    title.push(product.title);
  }
  return title.join(", ");
}
